import React, { Component } from "react";
import { Dialog } from "primereact/dialog";
import { Journaling } from "../../models/Journaling";
import moment from "moment";
import { AppCard } from "../../components/ui";
import { InputText } from "primereact/inputtext";
import Loader from "../../components/Loader";

interface JournalingDetailsDialogProps {
    isVisible: boolean;
    onHide: () => void;
    journaling: Journaling;
    editable: boolean;
}

interface JournalingDetailsDialogState {
    isDetailVisible: boolean;
    journaling: Journaling;
}

export default class JournalingDetailsDialog extends Component<JournalingDetailsDialogProps, JournalingDetailsDialogState> {
    constructor(props: JournalingDetailsDialogProps | Readonly<JournalingDetailsDialogProps>) {
        super(props);

        this.state = {
            isDetailVisible: false,
            journaling: this.props.journaling,
        };
    }

    toggleAdvancedMode = () => {
        this.setState({ isDetailVisible: !this.state.isDetailVisible });
    };

    render() {
        if (this.state.isDetailVisible) {
            return (
                <>
                    <Loader />
                </>
            );
        }

        if (this.state.journaling == null) {
            return "";
        }

        if (!this.props.isVisible) {
            return "";
        }

        return (
            <Dialog header="Journaling Details" visible={this.props.isVisible} style={{ width: "70vw" }} onHide={this.props.onHide}>
                <div className="space-y-4">
                    <AppCard><AppCard.Body>
                        {renderDualRow(
                            "Journaling Id",
                            this.state.journaling.id,
                            false,
                            (newVal: string) => {},
                            "Operation Type",
                            this.state.journaling.objectType,
                            false,
                            (newVal: string) => {},
                        )}
                        {renderDualRow(
                            "Made On",
                            moment.utc(this.state.journaling.madeOn).local().format("DD/MM/YYYY HH:mm:ss"),
                            false,
                            (newVal: string) => {},
                            "Application",
                            this.state.journaling.application,
                            false,
                            (newVal: string) => {},
                        )}
                        {renderDualRow(
                            "Made By",
                            this.state.journaling.madeBy,
                            false,
                            (newVal: string) => {},
                            "Made From IP Address",
                            this.state.journaling.madeFromIPAddress,
                            false,
                            (newVal: string) => {},
                        )}
                        {renderDualRow("Tenant Id", this.state.journaling.tenantId, false, (newVal: string) => {})}
                    </AppCard.Body></AppCard>

                    <AppCard><AppCard.Header title="Data Info" /><AppCard.Body>
                        {renderDualRow(
                            "Object Type",
                            this.state.journaling.objectType,
                            false,
                            (newVal: string) => {},
                            "Object",
                            this.state.journaling.object,
                            false,
                            (newVal: string) => {},
                        )}

                        {renderDualRow(
                            "Old Data",
                            this.state.journaling.oldData,
                            false,
                            (newVal: string) => {},
                            "New Data",
                            this.state.journaling.oldData,
                            false,
                            (newVal: string) => {},
                            true,
                        )}
                        {renderDualRow("Data", this.state.journaling.data, false, (newVal: string) => {})}
                    </AppCard.Body></AppCard>
                </div>
            </Dialog>
        );
    }
}

export function renderDualRow(
    title1: string,
    val1: string | number,
    editable1: boolean,
    onEdit1: (newval: string) => void,
    title2: string | null = null,
    val2: string | number = null as any,
    editable2: boolean = null as any,
    onEdit2: (newval: string) => void = null as any,
    applyOverFlow?: boolean,
) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 py-1">
            <div className="grid grid-cols-2 gap-2 items-center">
                <span className="text-sm font-bold text-neutral-700 dark:text-neutral-300">
                    {title1} :
                </span>
                <div className={applyOverFlow ? "overflow-auto" : undefined}>
                    {editable1 ? (
                        <InputText type="text" value={val1.toString()} onChange={(e) => onEdit1(e.target.value)} />
                    ) : (
                        <span className="text-sm text-neutral-600 dark:text-neutral-400">{val1}</span>
                    )}
                </div>
            </div>
            {title2 != null && (
                <div className="grid grid-cols-2 gap-2 items-center">
                    <span className="text-sm font-bold text-neutral-700 dark:text-neutral-300">
                        {title2} :
                    </span>
                    <div className={applyOverFlow ? "overflow-auto" : undefined}>
                        {editable2 ? (
                            <InputText type="text" value={val2.toString()} onChange={(e) => onEdit2(e.target.value)} />
                        ) : (
                            <span className="text-sm text-neutral-600 dark:text-neutral-400">{val2}</span>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
